import { http, HttpResponse } from 'msw'

import { api } from '@/utils/constants'

export const consume = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.user.CONSUME}`,
    () => {
        return HttpResponse.json()
    },
)
